export const space = {
  px: 1,
  xs: 4,
  sm: 8,
  base: 16,
  md: 24,
  lg: 32,
  xl: 64,
  '2xl': 128,
  '3xl': 256,
};
